
import { Injectable } from '@angular/core';
import { Observable ,of } from 'rxjs';
import { GetEnumValuesDto } from '../api/models';

@Injectable({
  providedIn: 'root'
})

export class SavedEnumsService {
  constructor() { }


  static savedEnums: SavedEnumDto[] = [];

  static pushEnum(newEnum: SavedEnumDto) {
    if (this.savedEnums.find((savedEnum) => { return savedEnum.enumName == newEnum.enumName })) return;
    this.savedEnums.push(newEnum);
  }

  static getEnum(enumName: string): GetEnumValuesDto[] {
    const searchedEnum = this.savedEnums.find((savedEnum) => { return savedEnum.enumName == enumName });
    if (searchedEnum) return searchedEnum.enumValue;
    else return null;
  }

  static getEnumAsObservable(enumName: string): Observable<GetEnumValuesDto[]> {
    const searchedEnum = this.savedEnums.find((savedEnum) => { return savedEnum.enumName == enumName });
    if (searchedEnum) return of(searchedEnum.enumValue);
    else return null;
  }


}


export class SavedEnumDto {
  enumName?: string;
  enumValue?: GetEnumValuesDto[]
}
